'use strict';

const { h, render } = require('phy');
const SelectWidgetDesktopContainer = require('../containers/select_widget_desktop_container');

const renderWidget = {
  init(payload, done) {
    const { selectWidget } = payload;
    if (!selectWidget || selectWidget.props.touchRequest) {
      done();
    }

    if (payload.iframeLogin) {
      const recreateIframe = true;
      window.IframeLogin.init(payload, () =>
        window.IframeLogin.lazyLoadIframe(recreateIframe)
      );
    }

    const container = document.querySelector('#select-widget-container');

    return render(
      h(SelectWidgetDesktopContainer, selectWidget.props),
      container,
      container.lastChild
    );
  },
};

module.exports = renderWidget;
